import {foundationTheme, isLocalStoragePhotoUrl} from 'platform/foundation';

import {IMAGE_SIZE} from '../../../constants/imageSize';

export const prepareAlbumImageUrl = (url: string) => {
  if (isLocalStoragePhotoUrl(url)) {
    return url;
  }

  const queryDelimiter = url?.includes('?') ? '&' : '?';
  // width query param is expecting pixels
  return `${url}${queryDelimiter}width=${IMAGE_SIZE.width * (foundationTheme.space.step * 16)}`;
};
